import React from 'react';
export function WorkersHeader() {
  return <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-4026">
      <div data-id="element-4027">
        <div className="flex items-center gap-2 mb-1" data-id="element-4028">
          <span className="text-xl font-bold text-gray-900" data-id="element-4029">BCG</span>
          <span className="text-gray-400" data-id="element-4030">|</span>
          <span className="text-sm text-gray-600 font-medium" data-id="element-4031">
            Broadway Construction Group
          </span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-4032">Workers</h1>
      </div>

      <div className="flex gap-3" data-id="element-4033">
        <div className="bg-gray-200 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4034">
          <div className="text-xl font-bold text-gray-900" data-id="element-4035">272</div>
          <div className="text-[10px] uppercase font-bold text-gray-600" data-id="element-4036">
            Present Today
          </div>
        </div>
        <div className="bg-amber-100 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4037">
          <div className="text-xl font-bold text-amber-600" data-id="element-4038">1</div>
          <div className="text-[10px] uppercase font-bold text-amber-600" data-id="element-4039">
            Expiring soon
          </div>
        </div>
        <div className="bg-red-100 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4040">
          <div className="text-xl font-bold text-red-600" data-id="element-4041">11</div>
          <div className="text-[10px] uppercase font-bold text-red-600" data-id="element-4042">
            Missing / expired
          </div>
        </div>
      </div>
    </div>;
}